module.exports = __webpack_public_path__ + "static/img/store_location.447d172e.png";